export const zIndex = {
  applicationMenu: '999',
  applicationHeader: '99'
}

export const headerHeight = '60px'
